import { render, staticRenderFns } from "./absence_pending_list.vue?vue&type=template&id=ea6096bc"
import script from "./absence_pending_list.vue?vue&type=script&lang=js"
export * from "./absence_pending_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports